// extracted by mini-css-extract-plugin
export var displayNone = "_tv-6";
export var imgContainer = "_tv-2";
export var overflowHidden = "_tv-3";
export var productInfoCardButtonContainer = "_tv-5";
export var productTitleText = "_tv-4";
export var rightArrow = "_tv-1";
export var rightArrowContainer = "_tv-0";